import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { VendorAdvertisementBannerComponent } from './vendor-advertisement-banner.component';
@NgModule({
  declarations: [VendorAdvertisementBannerComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [VendorAdvertisementBannerComponent],
})
export class BannerModule {}
